(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-licensed-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  // Masonry: drop each visible card into the shortest column, in order, so short cards leave no gaps.
  // Greedy placement keeps the first cards where they were when "show more" reveals the rest.
  const layout = section => {
    const grid = section.querySelector('.licensed-reviews__grid');
    if (!grid) return;
    grid.reviewCards ||= [...grid.querySelectorAll('.licensed-reviews__card')];
    const columns = Array.from({ length: mobile.matches ? 2 : 3 }, () => {
      const column = document.createElement('div');
      column.className = 'licensed-reviews__column';
      return column;
    });
    grid.classList.add('is-masonry');
    grid.replaceChildren(...columns);
    grid.reviewCards.forEach(card => {
      const target = card.hidden ? columns[0] : columns.reduce((a, b) => (b.offsetHeight < a.offsetHeight ? b : a));
      target.append(card);
    });
  };
  const connect = root => root.querySelectorAll('[data-review-section]').forEach(section => {
    if (section.dataset.connected) return;
    section.dataset.connected = 'true';
    const button = section.querySelector('[data-review-more]');
    if (button) {
      const cards = section.querySelectorAll('[data-extra-review]');
      cards.forEach(card => card.hidden = true);
      button.hidden = false;
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        cards.forEach(card => card.hidden = !expanded);
        layout(section);
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? window.theme.strings.fewerReviews : window.theme.strings.moreReviews;
        if (!expanded) section.scrollIntoView({ block: 'start' });
      });
    }
    layout(section);
  });
  const relayout = () => document.querySelectorAll('[data-review-section][data-connected]').forEach(layout);
  mobile.addEventListener('change', relayout);
  document.fonts?.ready.then(relayout);
  connect(document);
  document.addEventListener('shopify:section:load', event => connect(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["licensed-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  // Masonry: drop each visible card into the shortest column, in order, so short cards leave no gaps.
  // Greedy placement keeps the first cards where they were when "show more" reveals the rest.
  const layout = section => {
    const grid = section.querySelector('.licensed-reviews__grid');
    if (!grid) return;
    grid.reviewCards ||= [...grid.querySelectorAll('.licensed-reviews__card')];
    const columns = Array.from({ length: mobile.matches ? 2 : 3 }, () => {
      const column = document.createElement('div');
      column.className = 'licensed-reviews__column';
      return column;
    });
    grid.classList.add('is-masonry');
    grid.replaceChildren(...columns);
    grid.reviewCards.forEach(card => {
      const target = card.hidden ? columns[0] : columns.reduce((a, b) => (b.offsetHeight < a.offsetHeight ? b : a));
      target.append(card);
    });
  };
  const connect = root => root.querySelectorAll('[data-review-section]').forEach(section => {
    if (section.dataset.connected) return;
    section.dataset.connected = 'true';
    const button = section.querySelector('[data-review-more]');
    if (button) {
      const cards = section.querySelectorAll('[data-extra-review]');
      cards.forEach(card => card.hidden = true);
      button.hidden = false;
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        cards.forEach(card => card.hidden = !expanded);
        layout(section);
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? window.theme.strings.fewerReviews : window.theme.strings.moreReviews;
        if (!expanded) section.scrollIntoView({ block: 'start' });
      });
    }
    layout(section);
  });
  const relayout = () => document.querySelectorAll('[data-review-section][data-connected]').forEach(layout);
  mobile.addEventListener('change', relayout);
  document.fonts?.ready.then(relayout);
  connect(document);
  document.addEventListener('shopify:section:load', event => connect(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
